<template>
  <AppModalEdit
    v-model="isShowing"
    :loading="loading"
    :is-exec-button-disabled="!validatePassword"
    cancel-button-text="キャンセル"
    exec-button-text="保存"
    title="パスワード変更"
    @clickExec="savePassword"
  >
    <h2>注意</h2>
    <h3>
      パスワードは、半角英字（大文字・小文字）と数字を含む8文字以上で入力する必要があります。
    </h3>
    <v-text-field
      v-model="oldPassword"
      label="現在のパスワード"
      type="password"
      class="mt-4"
    />
    <v-text-field
      v-model="requestPassword"
      label="新しいパスワード"
      type="password"
    />
    <v-text-field v-model="retypePassword" label="確認" type="password" />
  </AppModalEdit>
</template>

<script>
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
// todo model化
import Account from '@/api/account'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldPassword: '',
      requestPassword: '',
      retypePassword: '',
      loading: false,
    }
  },
  computed: {
    isShowing: {
      get() {
        return this.value
      },
      set(isDisplay) {
        return this.$emit('input', isDisplay)
      },
    },
    validatePassword() {
      // 半角英字と数字両方を含む8文字以上
      const regex = /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,}$/
      return (
        this.requestPassword === this.retypePassword &&
        regex.test(this.requestPassword)
      )
    },
  },
  methods: {
    reset() {
      this.oldPassword = ''
      this.requestPassword = ''
      this.retypePassword = ''
      this.loading = false
    },
    async savePassword() {
      this.loading = true
      try {
        const requestBody = {
          oldPassword: this.oldPassword,
          requestPassword: this.requestPassword,
          retypePassword: this.retypePassword,
        }
        await Account.putPassword(requestBody)
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
      } catch (e) {
        const error = new Error('保存に失敗しました。')
        this.loading = false
        throw error
      }
      this.reset()
      this.isShowing = false
    },
  },
}
</script>
<style scoped></style>
